export default __webpack_public_path__ + "locales/sl/Common.json?hash=a086346eced63519843c6092c4fead1b";